import GovernmentsApi from './governments';
import members from './members';
import PublicCommentsApi from './public-comments';
import PublicSpeakersApi from './public-speakers';
import SeatApplicationsApi from './seat-applications';

export default {
  governments: GovernmentsApi,
  members,
  publicComments: PublicCommentsApi,
  publicSpeakers: PublicSpeakersApi,
  seatApplications: SeatApplicationsApi,
};
